import { http } from '@/app/lib/http/client'

// ─── Types ────────────────────────────────────────────────────────────────────

export interface Sucursal {
    id: number
    name: string
}



// ─── Service ──────────────────────────────────────────────────────────────────

export const layoutService = {
    async csrf() {
        const apiBase = import.meta.env.VITE_API_URL.replace(/\/api\/v1\/?$/, '')
        await http.get(`${apiBase}/sanctum/csrf-cookie`)
    },

    /**
     * Obtiene la lista de sucursales que tiene acceso el usuario actual.
     */
    async getMySucursales(): Promise<Sucursal[]> {
        const response = await http.get('/auth/my-sucursals')
        return response.data.data
    },


}